export default [
    'pxl.leads.su',
    'trkleads.ru',
    'trkleads.su',
    'order.zaim-srochno24.ru',
    'fintrendsc.ru',
];
